import cn from 'clsx';
import { forwardRef, HTMLAttributes } from 'react';

import s from './GuideDescription.module.scss';

type Props = HTMLAttributes<HTMLDivElement>;

const GuideDescription = forwardRef<HTMLDivElement, Props>((props, ref) => {
  const { children, className, ...rest } = props;

  return (
    <div className={cn(s.description, className)} ref={ref} {...rest}>
      {children}
    </div>
  );
});

export default GuideDescription;
